import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/apiService';
// Still import the SCSS but add inline styles as a fallback
import './RegisterTeam.scss';

// Simple test component to show first if rendering is broken
const RegisterTeamTest = () => {
  return (
    <div style={{ 
      width: '80%', 
      margin: '100px auto', 
      background: '#000', 
      color: '#fff',
      padding: '20px',
      textAlign: 'center',
      border: '1px solid #fff'
    }}>
      <h1>Register Team Form</h1>
      <p>This is a test to check rendering</p>
    </div>
  );
};

const styles = {
  container: {
    width: '100%',
    maxWidth: '600px',
    margin: '2rem auto',
    padding: '0 1.5rem',
  },
  content: {
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    borderRadius: '8px',
    padding: '2rem',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.5)',
  },
  logoContainer: {
    textAlign: 'center',
    marginBottom: '1.5rem',
  },
  logo: {
    width: '150px',
    height: '150px',
    margin: '0 auto',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  },
  heading: {
    fontFamily: "'Audiowide', sans-serif",
    margin: '1.5rem 0',
    textAlign: 'center',
    color: '#fff',
  },
  formGroup: {
    marginBottom: '1.5rem',
  },
  label: {
    display: 'block',
    marginBottom: '0.5rem',
    fontWeight: '500',
    textAlign: 'left',
    color: '#f0f0f0',
  },
  input: {
    width: '100%',
    padding: '0.75rem',
    borderRadius: '4px',
    border: '1px solid #333',
    backgroundColor: 'rgba(44, 44, 44, 0.7)',
    color: '#fff',
    fontSize: '1rem',
  },
  checkboxLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  button: {
    width: '100%',
    maxWidth: '300px',
    padding: '1rem',
    fontSize: '1.1rem',
    backgroundColor: '#ffd700',
    color: '#000',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  navigationButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '2rem',
  },
  nextButton: {
    backgroundColor: '#ffd700',
    color: '#000',
    border: 'none',
    borderRadius: '4px',
    padding: '0.75rem 1.5rem',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '1rem',
  },
  backButton: {
    backgroundColor: '#333',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    padding: '0.75rem 1.5rem',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '1rem',
  },
  stageIndicator: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '2rem',
  },
  stageItem: {
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    backgroundColor: '#333',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 0.5rem',
    fontSize: '0.9rem',
  },
  activeStage: {
    backgroundColor: '#ffd700',
    color: '#000',
  },
  completedStage: {
    backgroundColor: '#4cd137',
    color: '#fff',
  },
  stageLine: {
    flex: 1,
    height: '2px',
    backgroundColor: '#333',
    margin: 'auto 0.5rem',
  },
  errorMessage: {
    backgroundColor: 'rgba(255, 0, 0, 0.1)',
    color: '#ff6b6b',
    padding: '1rem',
    borderRadius: '4px',
    marginBottom: '1.5rem',
    textAlign: 'left',
  },
  successMessage: {
    backgroundColor: 'rgba(44, 44, 44, 0.7)',
    borderRadius: '8px',
    padding: '2rem',
    marginTop: '2rem',
    textAlign: 'center',
  },
  successHeading: {
    color: '#4cd137',
    marginBottom: '1rem',
  },
  successText: {
    marginBottom: '1.5rem',
    color: '#f0f0f0',
  },
  stageTitle: {
    textAlign: 'center',
    marginBottom: '1.5rem',
    color: '#ffd700',
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  academyLinkContainer: {
    marginTop: '1.5rem',
    padding: '1rem',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '4px',
    border: '1px solid #fff',
  },
  academyLink: {
    color: '#ffd700',
    textDecoration: 'underline',
    fontSize: '0.9rem',
  },
  linkBox: {
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    padding: '0.5rem 1rem',
    borderRadius: '4px',
    marginTop: '0.5rem',
    border: '1px solid #fff',
  },
};

const RegisterTeam = () => {
    // If having rendering issues, uncomment this line and comment out the rest of the component
    // return <RegisterTeamTest />;
    
    console.log('RegisterTeam component mounted'); // Debug log
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        // Team details
        teamName: '',
        teamType: '',
        playerPool: '',
        
        // Match settings
        maxPlayerLimit: '',
        selectionMethod: '',
        waitingList: '',
        permanentKeeper: '',
        
        // Financial details
        feeStructure: '',
        squadCosts: '',
        paymentCollection: '',
        hasTraining: '',
        
        // Logistics
        matchDay: '',
        venue: '',
        managerType: '',
        communication: '',
        
        // Additional info
        additionalComments: '',
        
        // Contact information
        contactName: '',
        contactMobile: '',
        contactRole: '',
        password: '',
        
        // System flags (not directly shown to user)
        isPlayer: false
    });
    
    const [currentStage, setCurrentStage] = useState(1);
    const totalStages = 5;
    
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [submittedTeamType, setSubmittedTeamType] = useState('');
    const [teamId, setTeamId] = useState(null); // Add state for team ID
    
    const stageFields = {
        1: ['teamName', 'teamType', 'playerPool'],
        2: ['maxPlayerLimit', 'selectionMethod', 'waitingList', 'permanentKeeper'],
        3: ['feeStructure', 'squadCosts', 'paymentCollection', 'hasTraining', 'matchDay', 'venue'],
        4: ['managerType', 'communication', 'additionalComments'],
        5: ['contactName', 'contactMobile', 'contactRole', 'password']
    };
    
    const stageTitles = {
        1: 'Team Information',
        2: 'Player Selection',
        3: 'Financial & Schedule Details',
        4: 'Management & Communication',
        5: 'Your Contact Details'
    };

    useEffect(() => {
        console.log('RegisterTeam useEffect running'); // Debug log
        // Add register-team-page class to body when component mounts
        document.body.classList.add('register-team-page');
        document.body.style.paddingTop = '20px';
        document.body.style.minHeight = '100vh';
        document.body.style.display = 'flex';
        document.body.style.alignItems = 'center';
        document.body.style.justifyContent = 'center';
        
        // Remove the class when component unmounts
        return () => {
            document.body.classList.remove('register-team-page');
            document.body.style.paddingTop = '';
            document.body.style.minHeight = '';
            document.body.style.display = '';
            document.body.style.alignItems = '';
            document.body.style.justifyContent = '';
        };
    }, []);

    // Add effect to set isPlayer flag based on teamType and managerType selections
    useEffect(() => {
        // For Academy teams, the user is always just a coach/manager (not a player)
        if (formData.teamType === 'Academy') {
            setFormData(prev => ({
                ...prev,
                isPlayer: false
            }));
        } 
        // For other team types, we check if they're a player-manager
        else if (formData.managerType === 'Player-manager') {
            setFormData(prev => ({
                ...prev,
                isPlayer: true
            }));
        }
        // Otherwise they're just a manager/coach
        else if (formData.managerType === 'Dedicated manager') {
            setFormData(prev => ({
                ...prev,
                isPlayer: false
            }));
        }
    }, [formData.teamType, formData.managerType]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };
    
    const validateStage = (stageNum) => {
        const fieldsToValidate = stageFields[stageNum];
        const errors = {};
        
        fieldsToValidate.forEach(field => {
            // Skip validation for optional fields
            if (field === 'squadCosts' && formData.teamType !== 'Formal 11v11') return;
            if (field === 'additionalComments') return;
            
            // Skip validation for conditionally hidden fields
            if (field === 'waitingList' && formData.maxPlayerLimit !== 'Yes') return;
            if (field === 'permanentKeeper' && formData.teamType === 'Formal 11v11') return;
            if (field === 'paymentCollection' && formData.teamType === 'Academy') return;
            if (field === 'matchDay' && formData.teamType === 'Academy') return;
            if (field === 'managerType' && formData.teamType === 'Academy') return;
            
            // Check required fields
            if (!formData[field] && typeof formData[field] !== 'boolean') {
                errors[field] = `This field is required`;
            }
        });
        
        // Special validation for password in stage 5
        if (stageNum === 5 && formData.password && formData.password.length < 8) {
            errors.password = 'Password must be at least 8 characters';
        }
        
        return Object.keys(errors).length === 0 ? null : errors;
    };

    const nextStage = () => {
        const stageErrors = validateStage(currentStage);
        if (stageErrors) {
            setError('Please fill in all required fields before proceeding.');
            return;
        }
        
        setError(null);
        if (currentStage < totalStages) {
            setCurrentStage(currentStage + 1);
            window.scrollTo(0, 0);
        }
    };

    const prevStage = () => {
        setError(null);
        if (currentStage > 1) {
            setCurrentStage(currentStage - 1);
            window.scrollTo(0, 0);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const stageErrors = validateStage(currentStage);
        if (stageErrors) {
            setError('Please fill in all required fields before submitting.');
            return;
        }
        
        setIsSubmitting(true);
        setError(null);

        try {
            // Store the team type before potentially clearing form data
            setSubmittedTeamType(formData.teamType);
            
            // Determine if the user is a player based on their selections
            const finalFormData = {
                ...formData,
                // For Academy teams, they're never players
                // For other teams, they're players if they selected player-manager
                isPlayer: formData.teamType === 'Academy' ? false : formData.managerType === 'Player-manager'
            };
            
            // If it's a Casual team, use the new endpoint for direct registration
            if (formData.teamType === 'Casual') {
                // Send registration data to the new endpoint
                const response = await api.post('register_form_team.php', finalFormData);

                if (response.data.success) {
                    setSuccess(true);
                    setTeamId(response.data.team_id); // Store team ID
                    // Clear form after successful submission
                    setFormData({
                        teamName: '',
                        teamType: '',
                        playerPool: '',
                        maxPlayerLimit: '',
                        selectionMethod: '',
                        waitingList: '',
                        permanentKeeper: '',
                        feeStructure: '',
                        squadCosts: '',
                        paymentCollection: '',
                        hasTraining: '',
                        matchDay: '',
                        venue: '',
                        managerType: '',
                        communication: '',
                        additionalComments: '',
                        contactName: '',
                        contactMobile: '',
                        contactRole: '',
                        password: '',
                        isPlayer: false
                    });
                } else {
                    setError(response.data.message || 'Failed to register team. Please try again.');
                }
            } else {
                // For non-Casual teams, use the same API but still use the new endpoint
                const response = await api.post('register_form_team.php', finalFormData);

                if (response.data.success) {
                    setSuccess(true);
                    setTeamId(response.data.team_id); // Store team ID
                    // Clear form after successful submission
                    setFormData({
                        teamName: '',
                        teamType: '',
                        playerPool: '',
                        maxPlayerLimit: '',
                        selectionMethod: '',
                        waitingList: '',
                        permanentKeeper: '',
                        feeStructure: '',
                        squadCosts: '',
                        paymentCollection: '',
                        hasTraining: '',
                        matchDay: '',
                        venue: '',
                        managerType: '',
                        communication: '',
                        additionalComments: '',
                        contactName: '',
                        contactMobile: '',
                        contactRole: '',
                        password: '',
                        isPlayer: false
                    });
                } else {
                    setError(response.data.message || 'Failed to register team. Please try again.');
                }
            }
        } catch (err) {
            console.error('Error:', err);
            setError('An error occurred while submitting the form. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };
    
    const renderStageIndicator = () => (
        <div style={styles.stageIndicator}>
            {[...Array(totalStages)].map((_, index) => (
                <React.Fragment key={index}>
                    <div 
                        style={{
                            ...styles.stageItem,
                            ...(currentStage === index + 1 ? styles.activeStage : {}),
                            ...(currentStage > index + 1 ? styles.completedStage : {})
                        }}
                    >
                        {index + 1}
                    </div>
                    {index < totalStages - 1 && (
                        <div 
                            style={{
                                ...styles.stageLine,
                                backgroundColor: currentStage > index + 1 ? '#4cd137' : '#333'
                            }}
                        />
                    )}
                </React.Fragment>
            ))}
        </div>
    );
    
    const renderStage = () => {
        switch (currentStage) {
            case 1:
                return (
                    <>
                        <div style={styles.stageTitle}>{stageTitles[1]}</div>
                        <div style={styles.formGroup} className="form-group">
                            <label style={styles.label} htmlFor="teamName">Team Name *</label>
                            <input
                                type="text"
                                id="teamName"
                                name="teamName"
                                value={formData.teamName}
                                onChange={handleChange}
                                required
                                placeholder="Enter your team name"
                                style={styles.input}
                                className="input-field"
                            />
                        </div>
                        
                        <div style={styles.formGroup} className="form-group">
                            <label style={styles.label} htmlFor="teamType">What type of team are you?</label>
                            <select
                                id="teamType"
                                name="teamType"
                                value={formData.teamType}
                                onChange={handleChange}
                                required
                                style={styles.input}
                                className="input-field"
                            >
                                <option value="">Select team type</option>
                                <option value="Casual">Casual (Plays weekly, non-league)</option>
                                <option value="Formal 11v11">Formal 11v11 squad (Saturday / Sunday League)</option>
                                <option value="Academy">Academy</option>
                            </select>
                        </div>

                        <div style={styles.formGroup} className="form-group">
                            <label style={styles.label} htmlFor="playerPool">How many players do you typically have in your pool?</label>
                            <input
                                type="number"
                                id="playerPool"
                                name="playerPool"
                                value={formData.playerPool}
                                onChange={handleChange}
                                required
                                min="1"
                                placeholder="Enter number of players"
                                style={styles.input}
                                className="input-field"
                            />
                        </div>
                    </>
                );
            case 2:
                return (
                    <>
                        <div style={styles.stageTitle}>{stageTitles[2]}</div>
                        <div style={styles.formGroup} className="form-group">
                            <label style={styles.label} htmlFor="maxPlayerLimit">Do you want to set a maximum player limit for matches?</label>
                            <select
                                id="maxPlayerLimit"
                                name="maxPlayerLimit"
                                value={formData.maxPlayerLimit}
                                onChange={handleChange}
                                required
                                style={styles.input}
                                className="input-field"
                            >
                                <option value="">Select option</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                                <option value="Depends on venue">Depends on venue</option>
                            </select>
                        </div>

                        <div style={styles.formGroup} className="form-group">
                            <label style={styles.label} htmlFor="selectionMethod">How do you select players for each game?</label>
                            <select
                                id="selectionMethod"
                                name="selectionMethod"
                                value={formData.selectionMethod}
                                onChange={handleChange}
                                required
                                style={styles.input}
                                className="input-field"
                            >
                                <option value="">Select method</option>
                                <option value="First come basis">First come basis</option>
                                <option value="Rotation system">Rotation system</option>
                                <option value="Performance based">Performance based</option>
                                <option value="Availability">Availability</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>

                        {formData.maxPlayerLimit === 'Yes' && (
                            <div style={styles.formGroup} className="form-group">
                                <label style={styles.label} htmlFor="waitingList">Would you like to enable a waiting list feature for when matches are full?</label>
                                <select
                                    id="waitingList"
                                    name="waitingList"
                                    value={formData.waitingList}
                                    onChange={handleChange}
                                    required
                                    style={styles.input}
                                    className="input-field"
                                >
                                    <option value="">Select option</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                    <option value="Not sure">Not sure</option>
                                </select>
                            </div>
                        )}

                        {formData.teamType !== 'Formal 11v11' && formData.teamType !== '' && (
                            <div style={styles.formGroup} className="form-group">
                                <label style={styles.label} htmlFor="permanentKeeper">In your matches, do you play with a goalkeeper?</label>
                                <select
                                    id="permanentKeeper"
                                    name="permanentKeeper"
                                    value={formData.permanentKeeper}
                                    onChange={handleChange}
                                    required
                                    style={styles.input}
                                    className="input-field"
                                >
                                    <option value="">Select option</option>
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                    <option value="null">Not sure</option>
                                </select>
                            </div>
                        )}
                    </>
                );
            case 3:
                return (
                    <>
                        <div style={styles.stageTitle}>{stageTitles[3]}</div>
                        <div style={styles.formGroup} className="form-group">
                            <label style={styles.label} htmlFor="feeStructure">What's your {formData.teamType === 'Academy' ? 'monthly fee structure' : 'standard match fee structure'}?</label>
                            <input
                                type="text"
                                id="feeStructure"
                                name="feeStructure"
                                value={formData.feeStructure}
                                onChange={handleChange}
                                required
                                placeholder={formData.teamType === 'Academy' ? "Enter details about your monthly fee structure" : "E.g. £5 per player, £50 per team"}
                                style={styles.input}
                                className="input-field"
                            />
                        </div>

                        {formData.teamType === 'Formal 11v11' && (
                            <div style={styles.formGroup} className="form-group">
                                <label style={styles.label} htmlFor="squadCosts">What are your squad-specific costs?</label>
                                <textarea
                                    id="squadCosts"
                                    name="squadCosts"
                                    value={formData.squadCosts}
                                    onChange={handleChange}
                                    placeholder="Enter details about squad costs, registrations, and other fees"
                                    style={{...styles.input, minHeight: '100px'}}
                                    className="input-field"
                                />
                            </div>
                        )}

                        {formData.teamType !== 'Academy' && (
                            <div style={styles.formGroup} className="form-group">
                                <label style={styles.label} htmlFor="paymentCollection">Do you collect payments before or after matches?</label>
                                <select
                                    id="paymentCollection"
                                    name="paymentCollection"
                                    value={formData.paymentCollection}
                                    onChange={handleChange}
                                    required
                                    style={styles.input}
                                    className="input-field"
                                >
                                    <option value="">Select option</option>
                                    <option value="Before match">Before match</option>
                                    <option value="After match">After match</option>
                                    <option value="Both options">Both options</option>
                                </select>
                            </div>
                        )}

                        <div style={styles.formGroup} className="form-group">
                            <label style={styles.label} htmlFor="hasTraining">Do you have training sessions?</label>
                            <select
                                id="hasTraining"
                                name="hasTraining"
                                value={formData.hasTraining}
                                onChange={handleChange}
                                required
                                style={styles.input}
                                className="input-field"
                            >
                                <option value="">Select option</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </div>

                        {formData.teamType !== 'Academy' && (
                            <div style={styles.formGroup} className="form-group">
                                <label style={styles.label} htmlFor="matchDay">What's your preferred day for regular matches?</label>
                                <select
                                    id="matchDay"
                                    name="matchDay"
                                    value={formData.matchDay}
                                    onChange={handleChange}
                                    required
                                    style={styles.input}
                                    className="input-field"
                                >
                                    <option value="">Select day</option>
                                    <option value="Monday">Monday</option>
                                    <option value="Tuesday">Tuesday</option>
                                    <option value="Wednesday">Wednesday</option>
                                    <option value="Thursday">Thursday</option>
                                    <option value="Friday">Friday</option>
                                    <option value="Saturday">Saturday</option>
                                    <option value="Sunday">Sunday</option>
                                </select>
                            </div>
                        )}

                        <div style={styles.formGroup} className="form-group">
                            <label style={styles.label} htmlFor="venue">Where is your home pitch?</label>
                            <input
                                type="text"
                                id="venue"
                                name="venue"
                                value={formData.venue}
                                onChange={handleChange}
                                required
                                placeholder="Enter the venue name or location"
                                style={styles.input}
                                className="input-field"
                            />
                        </div>
                    </>
                );
            case 4:
                return (
                    <>
                        <div style={styles.stageTitle}>{stageTitles[4]}</div>

                        {formData.teamType !== 'Academy' && (
                            <div style={styles.formGroup} className="form-group">
                                <label style={styles.label} htmlFor="managerType">Your Role in the Team</label>
                                <select
                                    id="managerType"
                                    name="managerType"
                                    value={formData.managerType}
                                    onChange={handleChange}
                                    required
                                    style={styles.input}
                                    className="input-field"
                                >
                                    <option value="">Select your role</option>
                                    <option value="Dedicated manager">I am only a Manager/Coach (I don't play)</option>
                                    <option value="Player-manager">I am a Player-Manager (I both play and manage)</option>
                                </select>
                            </div>
                        )}

                        <div style={styles.formGroup} className="form-group">
                            <label style={styles.label} htmlFor="communication">How do you currently communicate match details to players?</label>
                            <select
                                id="communication"
                                name="communication"
                                value={formData.communication}
                                onChange={handleChange}
                                required
                                style={styles.input}
                                className="input-field"
                            >
                                <option value="">Select communication method</option>
                                <option value="WhatsApp">WhatsApp</option>
                                <option value="Email">Email</option>
                                <option value="SMS">SMS</option>
                                <option value="Spond">Spond</option>
                                <option value="Teamer">Teamer</option>
                                <option value="Pitchero">Pitchero</option>
                                <option value="Facebook">Facebook</option>
                                <option value="Messenger">Facebook Messenger</option>
                                <option value="TeamSnap">TeamSnap</option>
                                <option value="Other app">Other app</option>
                            </select>
                        </div>

                        <div style={styles.formGroup} className="form-group">
                            <label style={styles.label} htmlFor="additionalComments">Any additional comments?</label>
                            <textarea
                                id="additionalComments"
                                name="additionalComments"
                                value={formData.additionalComments}
                                onChange={handleChange}
                                placeholder="Let us know if you have any other information or requirements"
                                style={{...styles.input, minHeight: '100px'}}
                                className="input-field"
                            />
                        </div>
                    </>
                );
            case 5:
                return (
                    <>
                        <div style={styles.stageTitle}>{stageTitles[5]}</div>
                        
                        <div style={styles.formGroup} className="form-group">
                            <label style={styles.label} htmlFor="contactName">Your Name *</label>
                            <input
                                type="text"
                                id="contactName"
                                name="contactName"
                                value={formData.contactName}
                                onChange={handleChange}
                                required
                                placeholder="Enter your full name"
                                style={styles.input}
                                className="input-field"
                            />
                        </div>
                        
                        <div style={styles.formGroup} className="form-group">
                            <label style={styles.label} htmlFor="contactRole">Your Role *</label>
                            <select
                                id="contactRole"
                                name="contactRole"
                                value={formData.contactRole}
                                onChange={handleChange}
                                required
                                style={styles.input}
                                className="input-field"
                            >
                                <option value="">Select your role</option>
                                <option value="Team Manager">Team Manager</option>
                                <option value="Coach">Coach</option>
                                <option value="Team Captain">Team Captain</option>
                                <option value="Team Admin">Team Admin</option>
                                <option value="Player">Player</option>
                                <option value="Owner">Owner</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>
                        
                        <div style={styles.formGroup} className="form-group">
                            <label style={styles.label} htmlFor="contactMobile">Your Mobile Number *</label>
                            <input
                                type="tel"
                                id="contactMobile"
                                name="contactMobile"
                                value={formData.contactMobile}
                                onChange={handleChange}
                                required
                                placeholder="Enter your mobile number"
                                style={styles.input}
                                className="input-field"
                            />
                        </div>
                        
                        <div style={styles.formGroup} className="form-group">
                            <label style={styles.label} htmlFor="password">Password *</label>
                            <input
                                type="password"
                                id="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                required
                                placeholder="Create a secure password"
                                style={styles.input}
                                className="input-field"
                                minLength="8"
                            />
                            <small style={{color: '#f0f0f0', marginTop: '5px', display: 'block'}}>
                                Password must be at least 8 characters
                            </small>
                        </div>
                    </>
                );
            default:
                return null;
        }
    };

    return (
        <div style={styles.container} className="register-team-container">
            <div style={styles.content} className="register-team-content">
                <div style={styles.logoContainer} className="logo-container">
                    {/* Use a direct text heading instead of an image that might not load */}
                    <h1 style={{
                        fontFamily: "'Audiowide', sans-serif",
                        fontSize: '2rem',
                        color: '#ffd700',
                        margin: '0'
                    }}>FOOTBALL</h1>
                </div>
                
                <h1 style={styles.heading}>Register Team</h1>
                
                {success ? (
                    <div style={styles.successMessage} className="success-message">
                        <h2 style={styles.successHeading}>Registration Successful!</h2>
                        {submittedTeamType === 'Casual' ? (
                            <>
                                <p style={styles.successText}>Thank you for registering your team. You will receive an SMS with your login details so you can start using the app right away!</p>
                                <p style={styles.successText}>Once you login, you can start creating matches and inviting players.</p>
                            </>
                        ) : submittedTeamType === 'Academy' ? (
                            <>
                                <p style={styles.successText}>Thank you for registering your academy. We will contact you shortly with your login details.</p>
                                <p style={styles.successText}>As a coach, you'll be able to add players, invite parents, and manage your academy team efficiently.</p>
                                {teamId && (
                                    <div style={styles.academyLinkContainer}>
                                        <p style={styles.successText}>Share this link with your coaches to showcase FirstWhistle:</p>
                                        <div style={styles.linkBox}>
                                            <a 
                                                href={`${window.location.origin}/academy-welcome?team_id=${teamId}&team_name=${encodeURIComponent(formData.teamName)}`}
                                                target="_blank" 
                                                rel="noopener noreferrer" 
                                                style={styles.academyLink}
                                            >
                                                {window.location.origin}/academy-welcome?team_id={teamId}&team_name={encodeURIComponent(formData.teamName)}
                                            </a>
                                        </div>
                                        <p style={styles.successText}>This link showcases what FirstWhistle can do for your academy!</p>
                                    </div>
                                )}
                            </>
                        ) : (
                            <>
                                <p style={styles.successText}>Thank you for registering your {submittedTeamType} team. We will contact you shortly with more information about next steps.</p>
                                {formData.managerType === 'Player-manager' && (
                                    <p style={styles.successText}>As both a player and manager, you'll be able to manage the team and participate in matches.</p>
                                )}
                                {formData.managerType === 'Dedicated manager' && (
                                    <p style={styles.successText}>As a manager, you'll be able to organize matches, manage players, and oversee your team.</p>
                                )}
                            </>
                        )}
                        <button 
                            onClick={() => navigate('/')} 
                            style={styles.button}
                            className="submit-button"
                        >
                            Back to Home
                        </button>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="form-group">
                        {renderStageIndicator()}
                        
                        {error && <div style={styles.errorMessage} className="error-message">{error}</div>}
                        
                        {renderStage()}
                        
                        <div style={styles.navigationButtons}>
                            {currentStage > 1 && (
                                <button 
                                    type="button" 
                                    onClick={prevStage}
                                    style={styles.backButton}
                                >
                                    Previous
                                </button>
                            )}
                            
                            {currentStage < totalStages ? (
                                <button 
                                    type="button" 
                                    onClick={nextStage}
                                    style={{
                                        ...styles.nextButton,
                                        marginLeft: currentStage === 1 ? 'auto' : '0'
                                    }}
                                >
                                    Next
                                </button>
                            ) : (
                                <button 
                                    type="submit" 
                                    style={{
                                        ...styles.nextButton,
                                        opacity: isSubmitting ? 0.7 : 1,
                                        cursor: isSubmitting ? 'not-allowed' : 'pointer'
                                    }}
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? 'Submitting...' : 'Register Team'}
                                </button>
                            )}
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
};

export default RegisterTeam; 